import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { getSigningAppointmentTransactionCategoryDisplayLabel } from '../../../../types/signingAppointment/ISigningAppointmentResponse';
import { useSelectCurrentOrder } from '../../../../selectors/order/selectCurrentOrder';
import { useSelectAppointmentFromPathParam } from '../../../../utilities/order/scheduling/useSomeAppointmentFromParam';
import { HeaderText2TW } from 'tailwindComponents/HeaderTextTW/HeaderTextTW';
import { AppointmentStatusBadge } from '../Reusable/AppointmentStatusBadge';
import { faEnvelope } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Show } from 'components/shared/Show';
import { Tooltip } from 'ui-toolkit';

export interface IAppointmentTitleProps {
  onClose: () => void;
}

export const AppointmentTitle: React.FC<IAppointmentTitleProps> = ({ onClose }) => {
  const { appointmentFromPath } = useSelectAppointmentFromPathParam();
  const { data: order } = useSelectCurrentOrder();

  if (!appointmentFromPath) return null;
  return (
    <div className={'flex flex-row justify-between'}>
      <div className={'flex flex-row items-center gap-2'}>
        <Show when={!!appointmentFromPath.isDigitalScheduling}>
          <Tooltip tooltipContent={'Digital Scheduling Appointment'} trigger={'hover'} placement={'top'}>
            <FontAwesomeIcon icon={faEnvelope} />
          </Tooltip>
        </Show>
        <HeaderText2TW className={'overflow-visible font-medium'}>
          {getSigningAppointmentTransactionCategoryDisplayLabel(
            appointmentFromPath,
            order.transaction.transaction_category,
            true // short title flag
          )}
        </HeaderText2TW>
      </div>
      <div className={'ml-auto flex flex-shrink-0 flex-row gap-2 whitespace-nowrap'}>
        <AppointmentStatusBadge appointment={appointmentFromPath} />
      </div>
      <div className={'ml-4'}>
        <XMarkIcon data-test-id="appointment-title-close-icon" onClick={onClose} className={'h-7 w-7 cursor-pointer'} />
      </div>
    </div>
  );
};
